<template>
  <div id="landing-page-guest" class="main" v-if="!loading">
    <header-view></header-view>
    <q-layout>
      <q-page-container style="padding-top: 0px;">
        <q-page>
          <div class="user-online" v-if="showOnline">Players Online: {{ userOnline }}</div>
          <router-view></router-view>
        </q-page>
      </q-page-container>

      <div class="footer">
        <p>Made by: review000</p>
        2023 All rights reserved.  
      </div>
    </q-layout>
  </div>
</template>

<script>
import HeaderView from '@/components/HeaderView.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'GuestLayout',
  components: {
    HeaderView
  },
  computed: {
    ...mapGetters({
      userOnline: 'home/getOnline',
      showOnline: 'home/getShowOnline'
    })
  },
  data () {
    return {
      loading: true
    }
  },
  methods: {
    ...mapActions({
      getInitialData: 'home/getInitialData'
    })
  },
  async mounted () {
    this.$q.loading.show()
    await this.recaptchaLoad('initial_data')

    await this.getInitialData()
      .then(() => {
        this.$q.loading.hide();
        this.loading = false
      })
      .catch(e => {
        if (e.response.data.exception.includes('MaintenanceMode')) {
          this.$q.loading.hide();
          this.$router.push("/maintenance");

          return
        }

        this.$q.notify({
            position: 'top-right',
            message: e.response.data.message,
            type: 'negative'
          })

          this.$q.loading.hide();
          this.loading = false
      });
  }
}
</script>

<style lang="scss">
.main {
  background-image: url('../assets/bg.png');
  background-repeat: no-repeat;
  background-size: auto;
  background-size: cover; 
  background-attachment: fixed;
  height: 100%;

  .q-layout {
    margin:0 auto;
    max-width: 1286px;

    padding-left: 25px;
    padding-right: 25px;
    padding-bottom: 40px;

    .user-online {
      background-color: green;
      border-radius: 15px;
      padding: 5px;
      margin-bottom: 8px;
      font-weight: 500;
      color: white;
      font-size: 12px;
      width: max-content;
      margin-left: auto;
    }

    .footer {
      left: auto;
      margin: 0;
      margin-top: 40px;
      color: white;
    }

  }
}
</style>